export default {"src":"/_next/static/media/community-projects.4ffd1f7f.svg","height":256,"width":353,"blurWidth":0,"blurHeight":0};